export interface JwtPayload {
  exp?: number;
  iat?: number;
  sub?: string;
  [key: string]: unknown;
}

/** Decodifica o payload de um JWT (sem validar assinatura — apenas UX no cliente). */
export function decodeJwtPayload(token: string): JwtPayload | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;

    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    return JSON.parse(jsonPayload) as JwtPayload;
  } catch {
    return null;
  }
}

export function getJwtExpirationSeconds(token: string): number | null {
  const payload = decodeJwtPayload(token);
  return typeof payload?.exp === 'number' ? payload.exp : null;
}

/** Margem de 30s antes do exp para evitar corrida com o relógio do servidor. */
export function isJwtExpired(token: string, skewSeconds = 30): boolean {
  const exp = getJwtExpirationSeconds(token);
  if (exp == null) return false;
  return exp <= Math.floor(Date.now() / 1000) + skewSeconds;
}

/** Segundos até o exp do JWT; null se não houver exp. */
export function getJwtSecondsUntilExpiry(token: string): number | null {
  const exp = getJwtExpirationSeconds(token);
  if (exp == null) return null;
  return exp - Math.floor(Date.now() / 1000);
}

/** true se o token ainda é válido e expira dentro de `withinSeconds`. */
export function isJwtExpiringSoon(token: string, withinSeconds: number): boolean {
  const remaining = getJwtSecondsUntilExpiry(token);
  if (remaining == null) return false;
  return remaining > 0 && remaining <= withinSeconds;
}
